import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"host-section"},[_c('div',{staticClass:"wrap",class:_vm.wrapClass},[_c(VContainer,[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }